import script from "./PaymentMethods.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethods.vue?vue&type=style&index=0&id=9324990c&lang=css"
import "./PaymentMethods.vue?vue&type=style&index=1&id=9324990c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9324990c"]])

export default __exports__